(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovynel-product-conversion-tools"] && !Shopify.designMode) return;
  try {
    
  function initRovynelProductTools() {
    document.querySelectorAll('[data-rvp-copy]').forEach(function(button) {
      button.addEventListener('click', function() {
        var url = button.getAttribute('data-rvp-copy');
        var status = button.closest('[data-rvp-tools]').querySelector('.rvp-tools__status');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function() {
            if (status) status.textContent = 'Product link copied.';
          });
        } else {
          if (status) status.textContent = url;
        }
      });
    });

    document.querySelectorAll('a[href="mailto:fsl@nnoll.com"]').forEach(function(link) {
      link.href = 'mailto:support@rovynel.com';
      link.textContent = 'support@rovynel.com';
    });

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.indexOf('fsl@nnoll.com') !== -1) {
        nodes.push(walker.currentNode);
      }
    }
    nodes.forEach(function(node) {
      node.nodeValue = node.nodeValue.replaceAll('fsl@nnoll.com', 'support@rovynel.com');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRovynelProductTools);
  } else {
    initRovynelProductTools();
  }

  } catch(e) { console.error(e); }
})();
})();
